<template>
  <w-icon-wrapper icon-name='work-check-icon'>
    <g
      id='_13_Check_Icon'
      data-name='13 Check_Icon'
      transform='translate(0.25 -0.121)'
    >
      <path
        id='Pfad_55663'
        d='M11.75.121a12,12,0,1,0,12,12A12,12,0,0,0,11.75.121Zm0,22a10,10,0,1,1,10-10A10.011,10.011,0,0,1,11.75,22.121Z'
        data-name='Pfad 55663'
        fill='currentColor'
      />
      <path
        id='Pfad_55664'
        d='M16.516,7.2,9.873,14.4,6.992,11.209A1,1,0,1,0,5.508,12.55l4.349,4.812,8.127-8.8A1,1,0,1,0,16.516,7.2Z'
        data-name='Pfad 55664'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCheck' };
</script>
